import {NzMessageService, NzModalService, UploadFile} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {HttpCommonService} from "../services/http-common.service";
import {Upload} from "./upload";

@Injectable()
export class ObjectGeneration {

  constructor(public httpService: HttpCommonService, public ngModalService: NzModalService, public showMsg: NzMessageService) {
  }

  // 生成新的对象
  getUploadObject(): Upload {
    return new Upload(this.httpService, this.ngModalService, this.showMsg);
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/models/ObjectGeneration.ts